/* eslint-disable max-len */

const StringConstantsMixin = {
  strings: {
    // utility to translate words in minfied JS
    START_TRANSLATE: 'START_TRANSLATE',
    CLOSE: 'Close',
    EXPAND_MAP: 'Expand map',
    SUCCESS: 'Success',
    TRAIL: 'Trail',
    TRAILS: 'Trails',
    NEAR: 'near',
    THAT_MATCH: 'that match',
    SENT: 'Sent',
    ICON: 'Icon',
    REQUIRED: 'Required',
    LIST_COPY: 'Copy to my lists',
    CLEAR_FILTERS: 'Clear filters',
    NO_RESULTS: 'No results',
    MAP_OPTIONS: 'Map options',
    MAP_TYPES: 'Map types',
    MAP_DETAILS: 'Map details',
    DIRECTIONS: 'Directions',
    PRINT_MAP: 'Print map',
    TERRAIN_AVAILABLE: '3D available',
    START: 'start',
    END: 'end',
    USER_AVATAR_ALT: `View user's profile page`,
    TOTAL: 'Total',
    DELETE_LIST_QUESTION: 'Are you sure you want to delete this list?',
    DELETE_ITEM_QUESTION: 'Are you sure you want to delete this from AllTrails?',
    TRAILS_NEAR: 'Trails near: ',
    MY_MAPS: 'My maps',
    MY_MAP: 'My map',
    MAP: 'Map',
    RECORDING: 'Activity',
    STATUS: 'Status',
    MY_RECORDINGS: 'My activities',
    VIEW_LIST_DETAILS: 'View list details',
    EXPLORE_TRAILS: 'Explore trails',
    PHOTOS: 'photos',
    PHOTO: 'Photo',
    WAYPOINT: 'Waypoint',
    DRAG_TO_DESIRED_LOCATION: 'Drag to desired location',
    LOCATION: 'Location',
    LISTS: 'Lists',
    LIST: 'List',
    PRIVATE_UPPER_CASE: 'Private',
    TITLE: 'Title',
    SHARE_YOUR_ROUTE: 'Share your route with others',
    RECORDINGS_HELP_OTHERS: 'Help other users find their next route. Upload your activity and inspire others.',
    ADD_YOUR_PHOTOS: 'Add photos of this trail',
    PHOTOS_HELP_OTHERS: 'Photos help others preview the trail. Upload photos about this trail to inspire others.',
    JOIN_THE_LIST: 'Join the list',
    USE_RECORDER_ZERO: 'Use Navigator in the AllTrails app and be the first outdoor explorer who has completed this trail.',
    USE_RECORDER_SINGULAR: 'Use Navigator in the AllTrails app and join the other outdoor explorer who has completed this trail.',
    USE_RECORDER_PLURAL: 'Use Navigator in the AllTrails app and join the {completedCount} other outdoor explorers who have completed this trail.',
    VIEW_USERS_RECORDING: "View {userName}'s activity",
    NOTES: 'Notes',
    OR: 'or',
    BACK: 'Back',
    CLEAR: 'Clear',
    CANCEL: 'Cancel',
    SUBMIT: 'Submit',
    MERGE: 'Merge',
    MOVE: 'Move',
    SAVE: 'Save',
    SAVED: 'Saved',
    SAVING: 'Saving...',
    UPLOAD: 'Upload',
    SMOOTH_FILE: 'Smooth file',
    EDIT: 'Edit',
    EDIT_LIST: 'Edit list',
    COMMENT: 'Comment',
    REMOVE: 'Remove',
    DONE: 'Done',
    DELETE: 'Delete',
    FAILED: 'Failed',
    HELP: 'Help',
    ERROR_OCCURRED: 'Error occurred',
    ERR_TRY_AGAIN: 'Error, please try again',
    MAPBOXGL_NOT_SUPPORTED:
      'It appears that your browser does not support MapboxGL, a library that is required to render maps on AllTrails.com. Please upgrade or change browsers before reloading the page. See https://docs.mapbox.com/help/troubleshooting/mapbox-browser-support/ for more details. Contact customer support with details about your device and browser if issue persists.',
    ADD: 'Add',
    SHARE: 'Share',
    SHOW_MORE: 'Show more',
    SHOW_LESS: 'Show less',
    REORDER: 'Reorder',
    SUGGEST: 'Suggest',
    LATITUDE: 'Latitude',
    LONGITUDE: 'Longitude',
    FAVORITE: 'Favorite',
    FAVORITED: 'Favorited',
    SAVE_FAVORITE: 'Save to your favorites',
    MORE_OPTIONS: 'More options',
    THANK_YOU: 'Thank you',
    CREATE_LIST: 'Create new list',
    CREATE: 'Create',
    SETTING: 'Setting...',
    DELETING: 'Deleting...',
    REMOVING: 'Removing...',
    SUGGESTING: 'Suggesting...',
    DELETED: 'Deleted',
    REMOVED: 'Removed',
    SET: 'Set',
    RECORDED: 'recorded',
    ROUTE_SET: 'Route set',
    FAILED_RETRY: 'Failed, retry?',
    SEE_ALL: 'See All',
    TOP: 'Top',
    RATING: 'Rating',
    PRIVATE: 'Private',
    REVIEW: 'Review',
    ACTIVITY: 'Activity type',
    TYPE: 'Type',
    DATE: 'Date',
    ON: 'on',
    REVIEWED: 'reviewed',
    SHOW_ORIGINAL: 'Show original',
    SHOW_TRANSLATION: 'Show translation',
    SAVE_TO: 'Save to',
    APPLY: 'Apply',
    RESET: 'Reset',
    SEE_RESULTS: 'See results ({resultsCount})',
    FILTER: 'Filter',
    SUNSET: 'Sunset',
    SUNRISE: 'Sunrise',
    UPLOADING: 'Uploading',
    UPDATE: 'Update',
    SEE_TRANSLATION: 'See translation',
    SEE_ORIGINAL: 'See original',
    X_MAP: '{x} Map',
    ABBREVIATIONS: {
      MILES: 'mi',
      FEET: 'ft',
      KILOMETERS: 'km',
      METERS: 'm'
    },
    SOMETHING_WENT_WRONG: 'Something went wrong',
    CLICK_RETRY: 'Click the button below to try again',
    PRIVACY_POLICY: {
      CONTENT: 'Content',
      PRIVACY_SETTINGS: 'Privacy settings',
      YOUR_NAME_YOUR_PROFILE_HOMETOWN: 'Your name, profile picture, and hometown may be seen by anyone who views your profile.',
      YOUR_CONTENT_DISPLAYED_WHEN_SOMEONE_ELSE:
        'Your content is displayed when someone views your profile. Choose your default level of privacy for each type of newly-created content. Changes made now will not affect the privacy levels of existing content.',
      YOUR_CONTENT_IS_VIEWED:
        'Your content is displayed when someone views your profile. Choose your default level of privacy for each type of content.',
      YOUR_CONTENT_TWO_PLACES:
        'Your content displays in two places: on your profile and in your followers’ feeds. Choose your default level of privacy for each type of content.',
      REVIEWS_AND_UPLOADED_SHARED:
        'Reviews and uploaded trail photos are shared with the AllTrails community to help others know what to expect out on the trail.',
      PUBLIC: 'Public',
      FOLLOWERS_ONLY: 'Followers only',
      ONLY_ME: 'Only me',
      YES: 'Yes',
      NO: 'No',
      MAP_PRIVACY: 'Map privacy',
      ACTIVITY_PRIVACY: 'Activity privacy',
      REQUIRE_FOLLOWER_REQUESTS: 'Require follower requests',
      ACTIVITIES_LABEL: 'Activities',
      YOUR_COMMUNITY: 'Your community',
      COMPLETED_TRAILS_LABEL: 'Completed trails',
      YOUR_COMMUNITY_INCLUDES: 'Your community includes who you follow and who follows you.',
      DO_NOT_REQUIRE_FOLLOWER_REQUESTS: 'Do not require follower requests.',
      REQUIRE_FOLLOW_REQUESTS: 'Require follower requests.',
      YOUR_COMMUNITY_IS_VISIBLE_ANYONE: 'Your community is visible to anyone.',
      YOUR_COMMUNITY_IS_VISIBLE_FOLLOWERS: 'Your community is only visible to your followers.',
      YOUR_COMMUNITY_VISIBLE_YOU: 'Your community is only visible to you.',
      YOUR_COMPLETED_TRAILS_DO_NOT_INCLUDE:
        'Your completed trails do not include the date or time the trail was completed, just that you’ve completed it.',
      YOUR_COMPLETED_TRAILS_VISIBLE_ANYONE: 'Your completed trails are visible to anyone.',
      YOUR_COMPLETED_TRAILS_VISIBLE_FOLLOWERS: 'Your completed trails are only visible to your followers.',
      YOUR_COMPLETED_TRAILS_VISIBLE_YOU: 'Your completed trails are only visible to you.',
      ANYTIME_YOU_USE_NAVIGATOR:
        'Anytime you use Navigator on the trail, you create an activity to save in your history. Each activity includes a date and time, along with your route and stats.',
      NOTE_PRIVACY_LEVEL_ACTIVITY: 'Note: You can always change the privacy level for any individual activity.',
      YOUR_ACTIVITIES_VISIBLE_ANYONE: 'Your activities are visible by anyone.',
      YOUR_ACTIVITIES_VISIBLE_FOLLOWERS: 'Your activities are only visible to your followers.',
      YOUR_ACTIVITIES_VISIBLE_YOU: 'Your activities are only visible to you.',
      THIS_INCLUDES_MAPS_CREATED_DOWNLOADED: 'This includes maps you’ve created or downloaded, along with those tied to an activity.',
      NOTE_PRIVACY_LEVEL_MAPS: 'Note: You can always change the privacy level for any individual map.',
      YOUR_MAPS_VISIBLE_ANYONE: 'Your maps are visible by anyone.',
      YOUR_MAPS_VISIBLE_FOLLOWERS: 'Your maps are only visible to your followers.',
      YOUR_MAPS_VISIBLE_YOU: 'Your maps are only visible to you.',
      THE_LISTS_YOU_CREATE: 'The lists you create can include activities, trails, and maps you’ve favorited.',
      YOU_CAN_ALWAYS_CHANGE_THE_PRIVACY: 'Note: You can always change the privacy level for any individual list.',
      YOUR_LISTS_VISIBLE_ANYONE: 'Your lists are visible by anyone.',
      YOUR_LISTS_VISIBLE_FOLLOWERS: 'Your lists are only visible to your followers.',
      YOUR_LISTS_VISIBLE_YOU: 'Your lists are only visible to you.',
      CHOOSE_WHO_CAN_VIEW_THIS_MAP: 'Choose who can view this map.',
      THIS_MAP_VISIBLE_ANYONE: 'This map is visible by anyone.',
      THIS_MAP_VISIBLE_FOLLOWERS: 'This map is only visible to your followers.',
      THIS_MAP_VISIBLE_YOU: 'This map is only visible to you.',
      CHOOSE_WHO_CAN_VIEW_THIS_ACTIVITY: 'Choose who can view this activity.',
      THIS_ACTIVITY_VISIBLE_ANYONE: 'This activity is visible by anyone.',
      THIS_ACTIVITY_VISIBLE_FOLLOWERS: 'This activity is only visible to your followers.',
      THIS_ACTIVITY_VISIBLE_YOU: 'This activity is only visible to you.',
      CHOOSE_WHO_CAN_VIEW_THIS_LIST: 'Choose who can view this list',
      THIS_LIST_VISIBLE_ANYONE: 'This list is visible by anyone.',
      THIS_LIST_VISIBLE_FOLLOWERS: 'This list is only visible to your followers.',
      THIS_LIST_VISIBLE_YOU: 'This list is only visible to you.',
      LIST_PRIVACY: 'List privacy',
      APPLY_TO_PAST_CONTENT: 'Apply to past content'
    },
    TIME: {
      MULTI_DAY: 'Multi-day'
    },
    ALT_TEXT: {
      CARET: 'Caret',
      YELLOW_STAR: 'Yellow Star',
      GRAY_STAR: 'Gray Star'
    },
    TRAIL_FORM_SUCCESS: {
      THANKS_FOR_REVIEW: 'Thanks for sharing',
      COMMUNITY_RELIES: 'Reviews like yours help people every day to feel confident on the trail.',
      PHOTOS_UPLOADED: 'Photos uploaded',
      YOURE_HELPING: 'You’re helping the community preview trails.',
      KEEP_SNAPPING_SHARING: 'Keep snapping and sharing!',
      KEEP_EM_COMING: 'Keep them coming!',
      RECORDING_UPLOADED: 'Activity uploaded',
      FIND_NEW_ROUTES: "You're helping the community find new routes.",
      KEEP_EXPLORING: 'Keep exploring!',
      ROUTE_UPLOADED: 'Route uploaded',
      ROUTE_ADDED: 'Route has been added to your map.',
      KEEP_CREATING: 'Keep creating!'
    },
    SEARCH: {
      SEARCH_FAVORITE_TRAILS: 'Search favorite trails...',
      SEARCH_COMPLETED_TRAILS: 'Search completed trails...',
      SHOWING_TRAIL_OF: 'Showing {amount} of {total} trails',
      SHOWING_TRAIL_OF_1: 'Showing {amount} of {total} trail',
      SHOWING_ITEM_OF: 'Showing {amount} of {total} items',
      SHOWING_ITEM_OF_1: 'Showing {amount} of {total} item',
      SHOWING_RECORDING_OF: 'Showing {amount} of {total} activities',
      SHOWING_RECORDING_OF_1: 'Showing {amount} of {total} activities',
      SHOWING_MAP_OF: 'Showing {amount} of {total} maps',
      SHOWING_MAP_OF_1: 'Showing {amount} of {total} map',
      SHOWING_PARK_OF_IN: '#{amount} of {total} {parks} in {location}',
      SHOW_MORE_PHOTOS: 'Show more photos',
      SHOW_MORE_REVIEWS: 'Show more reviews',
      SHOW_MORE_TRACKS: 'Show more activities',
      SHOW_MORE_COMPLETED: 'Show more completed',
      MAP_OF_TRAILS_IN: 'Map of trails in',
      MAP_OF_TRAILS_NEAR: 'Map of trails near',
      LOADING: 'Loading...',
      LOADING_NO_ELLIPSIS: 'Loading',
      SEARCH_LIST: 'Search list...',
      SEARCH_RECORDINGS: 'Search activities...',
      SEARCH_MAPS: 'Search maps...',
      ADD_TO_FAVORITES: 'Add to favorites',
      REMOVE_FROM_FAVORITES: 'Remove from favorites',
      ADD_TO_COMPLETED: 'Add to completed',
      REMOVE_FROM_COMPLETED: 'Remove from completed',
      ADD_TO_LIST: 'Add to list',
      REMOVE_FROM_LIST: 'Remove from list',
      MAP_LOAD_MSG: 'Hang in there while we load more details about the map',
      CLEAR_FILTERS_ALL_TRAILS: 'Clear your current search filters to see all trails.',
      ENTER_CITY_PARK_OR_TRAIL_NAME: 'Enter a city, park or trail name',
      ENTER_MEMBERS_NAME: "Enter a member's name...",
      CREATE_NEW_MAP: 'Create map',
      NO_RESULTS_FOUND: 'No results found',
      WE_COULDNT_FIND: 'We couldn’t find anything matching',
      SEARCH_NEARBY: 'Search nearby'
    },
    BREADCRUMB_ITEMS: {
      MEMBERS: 'Members',
      MAPS: 'Maps',
      RECORDINGS: 'Activities',
      LIFELINE: 'Lifeline'
    },
    MAP_LAYER_NAMES: {
      TERRAIN: 'Terrain',
      ROAD: 'Road',
      SATELLITE: 'Satellite',
      WORLD_PARKS: 'World parks'
    },
    DAYS_OF_WEEK: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    // maintain case of NON_HOUR_TIMES keys for api updates
    NON_HOUR_TIMES: {
      ALL_DAY: 'all day',
      CLOSED: 'closed',
      DAWN: 'dawn',
      DUSK: 'dusk'
    },
    TAB_NAMES: {
      DESCRIPTION: 'Description',
      OVERVIEW: 'Overview',
      WAYPOINTS: 'Waypoints',
      WEATHER: 'Weather',
      TIPS: 'Tips',
      CONTACT: 'Contact',
      REVIEWS: 'Reviews',
      PHOTOS: 'Photos',
      RECORDINGS: 'Activities',
      COMPLETED: 'Completed'
    },
    SEARCH_TAB_NAMES: {
      ALL: 'all',
      PLACES: 'places',
      PARKS: 'parks',
      TRAILS: 'trails',
      MAPS: 'maps',
      RECORDINGS: 'activities',
      LISTS: 'lists'
    },
    PARK_INFO: {
      TITLE: 'Park information',
      WEBSITE: 'Website',
      PHONE_NUMBER: 'Phone number',
      PARK_HOURS: 'Park hours',
      NATIONAL_PARKS: 'national parks',
      STATE_PARKS: 'state parks',
      LOCAL_PARKS: 'local parks',
      All_DAY: 'All day',
      CLOSED: 'Closed',
      COPY_TO_ALL: 'Copy to all',
      CLEAR_ALL: 'Clear all',
      OF: 'of',
      IN: 'in',
      TOP_TRAILS: 'Top trails',
      TOP_NATIONAL_PARKS: 'Top national parks',
      TOP_STATE_PARKS: 'Top state parks'
    },
    ALERTS: {
      TYPE_LABEL: 'Alert Type',
      TYPES: {
        WARNING: 'Advisory',
        INFORMATIONAL: 'Informational',
        CLOSURE: 'Closure'
      }
    },
    SORT: {
      atSort: 'AllTrails sort',
      desc: 'Newest first',
      asc: 'Oldest first',
      highestRated: 'Highest rated',
      lowestRated: 'Lowest rated',
      SORT: 'Sort'
    },
    TRACK_DETAIL: {
      HIDE: 'Hide',
      UNHIDE: 'Unhide',
      NEW_MAP: 'New map',
      ROUTE: 'Route',
      ROUTES: 'Routes',
      LINKED_TRAIL: 'Linked trail:',
      FINISH_DRAWING_ROUTE: 'Please finish drawing route (or cancel) before attempting to save.',
      DIRECTIONS: 'Directions',
      RECORDING_TITLE: 'Name (Optional)',
      RECORDING_DESCRIPTION: 'Description (Optional)',
      CANNOT_SAVE_UPDATE: 'Cannot save your update. Please try again.',
      CHOOSE_FILE_FORMAT: 'Select a file format',
      UNDO: 'Undo',
      REDO: 'Redo',
      ACTIONS: {
        OUT_AND_BACK: 'Double-back',
        REVERSE: 'Reverse',
        RETURN: 'Close loop'
      },
      ROUTING: 'Routing',
      DRAWING: 'Drawing',
      ROUTE_MODES: {
        HIKING: 'Hiking',
        MOUNTAIN_BIKING: 'Mountain biking',
        BIKE_TOURING: 'Bike touring',
        ROAD_BIKING: 'Road biking',
        OFF_ROAD_DRIVING: 'Off-road driving',
        SCENIC_DRIVING: 'Scenic driving'
      }
    },
    PROFILE: {
      PRIVACY: 'Privacy level',
      PUSH_NOTIFICATIONS: 'Push notifications'
    },
    STATS: {
      NORMAL: {
        PACE: 'Pace',
        TOTAL_TIME: 'Total time',
        STATS: 'Stats',
        SPLITS: 'Splits',
        PERSONAL_BESTS: 'Personal bests',
        DISTANCE: 'Distance',
        TOTAL_DISTANCE: 'Total distance',
        LONGEST_DISTANCE: 'Longest distance',
        MOVING_TIME: 'Moving time',
        ELEVATION_GAIN: 'Elevation gain',
        ELEV_GAIN: 'Elev gain',
        COUNT: 'Count',
        CALORIES: 'Calories',
        CALORIES_BURNED: 'Calories burned',
        LIFETIME_STATS: 'Lifetime stats',
        ANNUAL_STATS: 'Annual stats',
        RECORDED_IN: 'in',
        KILOMETERS: 'Kilometers',
        FEET: 'Feet',
        METERS: 'Meters',
        MILES: 'Miles',
        totalDistanceInYear: (distance, year) => `${distance} Total Distance in ${year}`,
        elevationGainInYear: (elevation, year) => `${elevation} Elevation Gain in ${year}`,
        movingTimeInYear: (time, year) => `${time} Moving Time in ${year}`,
        calorieInYear: (calories, year) => `${calories} Calorie in ${year}`,
        caloriesInYear: (calories, year) => `${calories} Calories in ${year}`,
        activityInYear: (numActivities, year) => `${numActivities} Activity in ${year}`,
        activitiesInYear: (numActivities, year) => `${numActivities} Activities in ${year}`
      },
      ABBR: {
        PER_MONTH: '/mo.'
      },
      LOWER: {
        CALORIES: 'calories',
        FEET: 'feet',
        HOURS: 'hours',
        KILOMETERS: 'kilometers',
        METERS: 'meters',
        MILES: 'miles',
        RECORDINGS: 'recordings'
      }
    },
    ELEV_CHART: {
      DISTANCE: 'Distance',
      ELEVATION: 'Elevation',
      GRADE: 'Grade',
      NO_DATA: 'No elevation data'
    },
    CONTRIBUTE: {
      UPLOAD_FILE: 'Upload file',
      DRAG_PHOTOS_HERE: {
        __html: 'Drag photos here or <span>browse files</span>'
      },
      DRAG_RECORDING_HERE: {
        __html: 'Drag activity here or <span>browse files</span>'
      },
      DRAG_ROUTE_HERE: {
        __html: 'Drag route here or <span>browse files</span>'
      },
      PNG_JPG_JPEG: 'PNG, JPG or JPEG',
      GPX_TPO_FIT_TCX: 'GPX, TPO, FIT, TCX, KML, or KMZ'
    },
    LIFELINE: {
      TRACK_PROGRESS: 'Track progress',
      VIEW_ROUTE: 'View Planned Route',
      LIVE_UPDATES: 'See Live Updates',
      SEE_COMPLETED: 'See Completed Activity',
      COMPLETED_DATA: 'Completed Activity Details',
      PLANNED_DETAILS: 'Planned Activity Details',
      KEEP_ADVENTURERS_SAFE: 'Keeping adventurers safe on the trail',
      SMS_RATES: 'Standard SMS rates will apply to messages you receive.  Live tracking can only update when the user’s phone has a data signal.',
      MORE_INFO: 'More Info',
      NOT_STARTED_YET: 'Not Started Yet or No Data Signal',
      FINISHED_AND_SAFE: 'Finished & Reported Safe',
      ACTIVITY_IN_PROGRESS: 'Activity In Progress',
      DIRECTIONS_TRAILHEAD: 'Directions to Trailhead',
      LAST_RECORDED: 'LAST RECORDED TIME',
      LAST_RECORDED_LOC: 'LAST RECORDED LOCATION',
      ACTUAL_START: 'ACTUAL START TIME',
      PLANNED_START: 'PLANNED START TIME',
      PLANNED_END: 'PLANNED END TIME',
      ACTUAL_DISTANCE: 'ACTUAL DISTANCE',
      PLANNED_DISTANCE: 'PLANNED DISTANCE',
      ACTUAL_ELEV: 'ACTUAL ELEVATION GAIN',
      PLANNED_ELEV: 'PLANNED ELEVATION GAIN',
      NOT_STARTED: 'Not Started',
      NO_DATA_RECEIVED: 'No Data Received',
      GET_DETAILS: 'Get the details before they hit the trail. See planned start and end times for their upcoming adventure.',
      STAY_INFORMED: 'Stay informed and track progress. Follow where they are on an easy-to-read map.',
      SEE_STATS: 'See stats like total distance and elevation gain to track their accomplishments.',
      STAY_IN_CONTACT: "Stay in contact. We’ll notify you once they're back safely or if they're running late.",
      OVERDUE: 'Overdue',
      SCHEDULED_END: 'Scheduled end time:',
      SCHEDULED_START: 'Scheduled start time:',
      SHARED_MSG:
        "Has shared a Lifeline with you.  You can follow {userFirstName}'s real-time location during the activity.  If you or {userFirstName} encounter limited GPS or data coverage, Lifeline information could be delayed.",
      LATE_START:
        '{userFirstName} planned to start this activity by now, but either doesn’t have a data connection, or isn’t navigating in the AllTrails app yet. Please check back in a bit.',
      DO_NOT_PANIC: 'Do not panic',
      EMERGENCY: 'Emergency Services',
      REASSURANCE_MSG:
        "It is likely {userFirstName} is alright. {userFirstName}'s phone may have lost connection, battery power, or {userFirstName} is running behind and still enjoying the trail.",
      PROVIDE_INFO:
        'If you have reason to believe {userFirstName} is in danger, contact local authorities associated with the trail.  Please provide the trail information below to local emergency services.'
    },
    OVERLAYS: {
      WEATHER: 'Weather',
      AIR_QUALITY: 'Air quality',
      POLLEN: 'Pollen',
      LIGHT: 'Light pollution',
      FIRE_HISTORY: 'Fire history',
      NEARBY_TRAILS: 'Nearby trails',
      HEATMAP: 'Heatmap',
      PHOTOS: 'Photos',
      WAYPOINTS: 'Waypoints',
      US_CONTOURS: 'US contours',
      WAYMARKED_HIKING: 'Waymarked hiking',
      WAYMARKED_CYCLING: 'Waymarked cycling',
      WAYMARKED_MTB: 'Waymarked MTB',
      DISTANCE_MARKERS: 'Distance markers'
    },
    FILTERS: {
      TRAIL_COMPLETION: 'Trail completion',
      TRAIL_LINKED: 'Linked to trail',
      TRAIL_UNLINKED: 'Not linked to trail',
      DIFFICULTY: 'Difficulty',
      ACTIVITY: 'What to do',
      ACTIVITY_LABEL: 'Activity',
      FEATURES: 'What to see',
      FEATURES_LABEL: 'Attractions',
      SUITABILITY: 'Suitability',
      CITY: 'City',
      STATE: 'State',
      COUNTRY: 'Country',
      ELEV_GAIN: 'Elevation gain',
      LENGTH: 'Length',
      TIME: 'Time',
      EST: 'Est.',
      ROUTE_TYPE: 'Route type',
      TRAIL_TRAFFIC: 'Trail traffic',
      RATING: 'Rating',
      SORT: 'Sort by',
      SORT_LABEL: 'Sort',
      DISTANCE_AWAY: 'Distance away',
      AND_UP: '& up',
      ACTIVITIES: {
        BACKPACKING: 'Backpacking',
        BIKE_TOURING: 'Bike touring',
        BIRDING: 'Bird watching',
        CAMPING: 'Camping',
        CROSS_COUNTRY_SKIING: 'Cross-country skiing',
        FISHING: 'Fishing',
        HIKING: 'Hiking',
        HORSEBACK_RIDING: 'Horseback riding',
        MOUNTAIN_BIKING: 'Mountain biking',
        OFF_ROAD_DRIVING: 'Off-road driving',
        PADDLE_SPORTS: 'Paddle sports',
        ROAD_BIKING: 'Road biking',
        ROCK_CLIMBING: 'Rock climbing',
        SCENIC_DRIVING: 'Scenic driving',
        SKIING: 'Skiing',
        SNOWSHOEING: 'Snowshoeing',
        SURFING: 'Surfing',
        TRAIL_RUNNING: 'Running',
        RUNNING: 'Running',
        VIA_FERRATA: 'Via ferrata',
        WALKING: 'Walking',
        BIRD_WATCHING: 'Bird watching'
      },
      FEATURE_TYPES: {
        BEACH: 'Beach',
        CAVE: 'Cave',
        CITY_WALK: 'City walk',
        EVENT: 'Event',
        FOREST: 'Forest',
        HISTORIC_SITE: 'Historic site',
        HOT_SPRINGS: 'Hot springs',
        LAKE: 'Lake',
        PUB_WALK: 'Pub walk',
        PUB_CRAWL: 'Pub walk',
        RAILS_TRAILS: 'Rails trails',
        RIVER: 'River',
        VIEWS: 'Views',
        WATERFALL: 'Waterfall',
        WILD_FLOWERS: 'Wildflowers',
        WILDLIFE: 'Wildlife'
      },
      OBSTACLES: {
        BLOWDOWN: 'Blowdown',
        BRIDGE_OUT: 'Bridge out',
        BUGS: 'Bugs',
        CLOSED: 'Closed',
        FEE: 'Fee',
        FLOODED: 'Flooded',
        GREAT: 'Great!',
        ICY: 'Icy',
        MUDDY: 'Muddy',
        NO_SHADE: 'No shade',
        OFF_TRAIL: 'Off trail',
        OVER_GROWN: 'Overgrown',
        PRIVATE_PROPERTY: 'Private property',
        ROCKY: 'Rocky',
        SCRAMBLE: 'Scramble',
        SNOW: 'Snow',
        WASHED_OUT: 'Washed out'
      },
      ACCESS: {
        ADA: 'Wheelchair friendly',
        WHEELCHAIR_FRIENDLY: 'Wheelchair friendly',
        DOGS: 'Dog friendly',
        DOGS_LEASH: 'Dogs on leash',
        DOGS_ON_LEASH: 'Dogs on leash',
        KIDS: 'Kid friendly',
        KID_FRIENDLY: 'Kid friendly',
        NO_DOGS: 'No dogs',
        DOGS_NO: 'No dogs',
        PARTIALLY_PAVED: 'Partially paved',
        PAVED: 'Paved',
        STROLLERS: 'Stroller friendly',
        STROLLER_FRIENDLY: 'Stroller friendly'
      },
      ROUTE_TYPES: {
        LOOP: 'Loop',
        OUT_AND_BACK: 'Out & back',
        POINT_TO_POINT: 'Point to point'
      },
      USAGES: {
        LIGHT: 'Light',
        MODERATE: 'Moderate',
        HEAVY: 'Heavy'
      },
      SORT_TYPES: {
        BEST_MATCH: 'Best match',
        MOST_POPULAR: 'Most popular',
        NEWLY_ADDED: 'Newly added',
        CLOSEST: 'Closest',
        LIST_ORDER: 'List order',
        DATE: 'Date',
        NAME: 'Name',
        RECENTLY_ADDED: 'Recently added'
      },
      COMPLETED: 'Completed',
      UNCOMPLETED: 'Not completed',
      VERIFIED: 'Verified completed',
      UNVERIFIED: 'Completed',
      OPEN: 'Open'
    },
    MOBILE: {
      TEXT_LINK: 'Text link',
      SENT: 'Sent',
      SENDING: 'Sending',
      ERROR_SEND_TEXT: 'There was a problem sending the text.  Please check the number and try again.'
    },
    DIFFICULTY: {
      CAPS: {
        DEFAULT: 'DIFFICULTY',
        EASY: 'EASY',
        MODERATE: 'MODERATE',
        HARD: 'HARD'
      },
      LOWER: {
        DEFAULT: 'difficulty',
        EASY: 'easy',
        MODERATE: 'moderate',
        HARD: 'hard'
      },
      NORMAL: {
        EASY: 'Easy',
        MODERATE: 'Moderate',
        HARD: 'Hard',
        DIFFICULT: 'Difficult'
      }
    },
    SIGNUP: {
      AT_LEAST_SIX_CHARS: 'Must be at least 6 characters',
      EMAIL: 'Email',
      PASSWORD: 'Password',
      FIRST_NAME: 'First name',
      LAST_NAME: 'Last name',
      LOGIN: 'Log in',
      SIGNUP: 'Sign up'
    },
    CONVERTER: {
      CONVERTER_SUCCESS: {
        MAPS: 'Maps'
      }
    },
    COMMUNITY: {
      COMMUNITY: 'Community',
      EMPTY_STATES: {
        RETRY: 'Retry'
      },
      CONTACTS: 'Contacts',
      CONNECT: {
        CONNECT: 'Connect',
        VIEW_ALL: 'View all',
        FOLLOWER_REQUESTS: 'Follower requests'
      },
      BELAY_CONNECTIONS: {
        BLOCKING: 'Blocking',
        UNBLOCKING: 'Unblocking'
      }
    },
    EMPTY_STATES: {
      FAVORITES: {
        START_SAVING_TRAILS: 'Start saving trails',
        TAP_THE_HEART_ICON: 'Tap the bookmark icon on any trail to turn this into your adventure wishlist.'
      },
      MAPS: {
        CREATE_YOUR_OWN_MAP: 'Create your own map',
        MAP_CREATOR_TOOL: 'Use the AllTrails map creator tool to build custom routes.'
      },
      ACTIVITIES: {
        KEEP_TRACK_ACTIVITIES: 'Keep track of your activities',
        SAVE_ACTIVITIES:
          'Save activities by navigating your route in the AllTrails app. On desktop, upload activities from Garmin, Google, and more.',
        UPLOAD_FILE: 'Upload file'
      },
      COMPLETED: {
        START_COMPLETING_TRAILS: 'Start completing trails',
        COMPLETED_TAB_LIST: 'Log your completed trails by using the AllTrails app to Navigate.'
      },
      CUSTOM: {
        ADD_TRAILS_TO_LIST: 'Add trails to your list',
        PERSONAL_LIST_SUBTEXT: 'Tap the save icon on any trail, then select this list name to start adding to it.'
      }
    },
    NAVIGATION: {
      LOGIN: 'Log In',
      SIGNUP: 'Sign Up',
      LOGOUT: 'Logout',
      SETTINGS: 'Settings',
      MEMBERS: 'Members',
      PHOTOS: 'Photos',
      REVIEWS: 'Reviews',
      PROFILE: 'Profile',
      ACTIVITIES: 'Activities',
      COMMUNITY: 'Community',
      EXPLORE: 'Explore',
      PLAN: 'Plan',
      MY_FAVORITES: 'My favorites',
      LISTS: 'Lists',
      MY_MAPS: 'My maps',
      HISTORY: 'History',
      RECORDINGS: 'Activities',
      COMPLETED: 'Completed',
      STATS: 'Stats',
      HELP: 'Help',
      SAVED: 'Saved'
    },
    NAVIGATOR_MODAL: {
      HEAD_TO_THE: 'Head to the AllTrails app on your iOS or Android phone to begin navigating.', // Alternate sub-heading for non-english languages
      ANY_NUMBER:
        'Please note: Any number you enter here is just for you. We won’t save your information or contact you without permission. Texting is only available for United States mobile numbers.'
    },
    SHARE_MODAL: {
      SMS_INSTRUCTIONS: 'Text this trail to your friends, family or yourself so you can get driving directions and see detailed trail maps on the go.'
    },
    MAP_CREATOR: {
      ACTIVITY: 'Activity',
      ADD_AS_NEW_MAP: 'Add as new map',
      ADD_TO_ROUTE: 'Add to route',
      CLICK_TO_ADD_POINT: 'Click to add point',
      CLOSE_POPUP: 'Close popup',
      CREATE_A_CUSTOM_MAP: 'Create a custom map',
      DESCRIPTION_LABEL: 'Add notes about your route',
      DESCRIPTION: 'Description',
      DRAG_TO_CHANGE_DELETE_TO_REMOVE: "Drag to change route, 'delete' to remove",
      DRAW_ON_MAP: 'Draw on map',
      EASILY_PLAN_THE_PERFECT_PATH: 'Easily plan the perfect path for your next hike, bike, or run with our Map Creator tool.',
      EDIT_MAP: 'Edit map',
      ERROR_SAVING: 'Error saving',
      NEW_MAP_CREATED: 'New map created',
      PHOTOS: 'Photos',
      PRIVATE: 'Make map private',
      SAVE_CUSTOM_MAP: 'Save custom map',
      SEARCH_FOR_LOCATION: 'Search for a location or click anywhere on the map to draw',
      SEARCH_OR_CLICK_ON_MAP_TO_START: 'Search or click on the map to start',
      START_HERE: 'Start here',
      SUGGEST_AS_NEW_TRAIL: 'Suggest as new trail',
      TITLE_LABEL: 'Name your map',
      UPLOAD_FROM_FILE: 'Upload from file',
      WAYPOINT_ERROR: 'There has been an error, please try again',
      WAYPOINTS: 'Waypoints',
      YOUR_ROUTE: 'Your route',
      ROUTE_WITH_NUMBER: number => `Route ${number}`
    },
    PRINT_PAGE: {
      PRINT_MAP: 'Print map', // Lower case m for the title
      PRINT_YOUR_OWN: 'Print your own customizable maps for backup.',
      PAPER_SIZE: 'Paper size',
      ORIENTATION: 'Orientation',
      GRID: 'Grid',
      SCALE: 'Scale',
      DOWNLOAD_PDF: 'Download PDF',
      PRINT_MAP_BUTTON: 'Print Map', // Capital M for the button
      LEARN_MORE: 'Learn more',
      PAPER_LETTER_IMPERIAL: 'Letter',
      PAPER_LETTER_METRIC: 'A4',
      PAPER_LEGAL_IMPERIAL: 'Legal',
      PAPER_LEGAL_METRIC: 'A3',
      PAPER_TABLOID_IMPERIAL: 'Tabloid',
      PAPER_TABLOID_METRIC: 'A2',
      PAPER_CUSTOM: 'Custom',
      LAYOUT: 'Layout',
      ORIENTATION_PORTRAIT: 'Portrait',
      ORIENTATION_VERTICAL: 'Vertical',
      ORIENTATION_LANDSCAPE: 'Landscape',
      ORIENTATION_HORIZONTAL: 'Horizontal',
      GRID_DECIMAL: 'Decimal',
      MILES: 'MILES',
      METERS: 'METERS',
      PRINT_SETTINGS: 'Print settings',
      CREATE_CUSTOM_MAP: 'Create custom map',
      GAIN: 'Gain',
      LOSS: 'Loss',
      NONE_OPTION: 'None',
      EXACT: 'Exact'
    },
    TAKE_YOUR_ALLTRAILS: 'Take your AllTrails experience on the go',
    TRY_THE_ALLTRAILS_APP: 'Try the AllTrails app for your iOS or Android phone. Enter your US mobile number to text yourself a link.',
    GET_MORE_FROM: 'Get more from AllTrails when you download the app on your iOS or Android phone.',
    DOWNLOAD_THE_APP: 'Download the app',
    THERE_WAS_A_PROBLEM_SENDING_THE_TEXT: 'There was a problem sending the text.',
    PLEASE_CHECK_THE_NUMBER_AND_TRY_AGAIN: 'Please check the number and try again.',
    DOWNLOAD_THE_FREE_APP: 'Download the free app',
    HEART_ICON: 'heart icon',
    A_PERSON_WTIH_LONG_BROWN_HAIR_IS_WEARING_ORANGE_PANTS:
      'A person with long brown hair is wearing orange pants, a red long sleeve shirt, and a grey beanie while standing on a brown rock with their hands in their pockets. There is brown grass in the foreground and they are looking out over an ocean and beach with blue sky in the background.',
    TWO_PEOPLE_ARE:
      'Two people are walking on a dirt single-track trail on top of a gentle green hill towards a coastline with churning white waves and blue sky. The trail appears to end at an overlook with a view to the left of a beach and dirt cliffs with green trees.',
    A_SMILING_PERSON:
      'A smiling person with long brown hair is wearing brown pants and a plaid blue and maroon shirt. They are balancing on one foot on a log in a lake. There is a mountain covered with snow and some green trees in the background that is reflected in the clear lake water. The sun is shining in the blue sky. ',
    A_PERSON_WTIH_LONG_BROWN_HAIR_IS_WEARING_A_BLACK_HAT:
      'A person with long brown hair is wearing a black hat, red puffer jacket, and black pants with an orange and black backpack. They are standing on green grass with small yellow flowers looking over a coastline of green cliffs, black sand, blue water, and blue sky.',
    ALLTRAILS: 'AllTrails',
    END_TRANSLATE: 'END_TRANSLATE'
  },
  constants: {
    XLATE: {
      GOOGLE: 'xlate-google',
      NONE: 'xlate-none'
    },
    APPLE_SIWA: {
      AUTHORIZE_URL: 'https://appleid.apple.com/auth/authorize',
      AUTHORIZE_PARAMS: '?response_type=code%20id_token&response_mode=form_post',
      CLIENT_ID: 'com.alltrails.AllTrails.web',
      SCOPES: 'name email',
      REDIRECT_PATH: '/users/auth/apple/callback'
    },
    MAGIC: {
      ANONYMOUS_MAP_USERNAME: 'alltrails-guest-maps'
    }
  },
  // returns value or original string if not found in supplied dictionary
  stringsLookup(dict, str) {
    if (!str) {
      console.error('Provided null `str` value lookup');
      return '';
    }
    const key = str.toUpperCase().replace(/ /g, '_');
    return dict[key] || str;
  }
};

const ProPageStrings = {
  START_TRANSLATE: 'START_TRANSLATE',
  loginForm: {
    email: {
      title: 'Email',
      validation: {
        generic: 'Email is not valid.'
      }
    },
    firstName: {
      title: 'First name',
      validation: {
        generic: 'Enter your first name.'
      }
    },
    lastName: {
      title: 'Last name',
      validation: {
        generic: 'Enter your last name.'
      }
    },
    password: {
      title: 'Password',
      validation: {
        generic: 'Password must be 6 characters long.'
      }
    }
  },
  END_TRANSLATE: 'END_TRANSLATE'
};

export { StringConstantsMixin, ProPageStrings };
